export default __webpack_public_path__ + "static/media/rhenus-z.45c07992.svg";